import { SectionTabs } from './SectionTabs'
import type { DotKind } from './NavDot'
import type { DotKey, NavItem } from './navGroups'

interface Props {
  /** Shown above the tabs: the gym bar on Home. */
  lead?: React.ReactNode
  items: NavItem[]
  dots?: Partial<Record<DotKey, DotKind | false>>
}

/**
 * The sub-navigation for the current tab, on a phone.
 *
 * The tabs sit flush on the header's bottom edge, so the active underline
 * lands on the hairline the way a tab does.
 *
 * It used to carry a gym switcher row above these pills. On the dashboard that
 * row sat directly above the gym's own cover photo, logo and name — the same
 * gym, said twice, for about 48px of a screen that is mostly reached one-handed
 * in a gym. Switching gyms lives on the Me tab instead, and on the desktop
 * sidebar, where there is room for it.
 *
 * A tab with a single destination has nothing to navigate between, so it gets
 * no tabs. Home still gets a header: the gym bar, which stays put while the
 * page scrolls under it.
 */
export function AppHeader({ lead, items, dots }: Props) {
  if (!lead && items.length < 2) return null

  return (
    <header className="sticky top-0 z-[var(--z-nav)] border-b border-[var(--gym-line)] bg-[var(--gym-bar)]/95 pt-[var(--safe-t)] backdrop-blur-xl md:hidden">
      {lead}
      <SectionTabs items={items} dots={dots} />
    </header>
  )
}
